// Per-device interface zoom. Drives the CSS var used by the desktop/tablet zoom media query
// in index.css (`@media (min-width:768px){ html{ zoom: var(--gv-zoom, 0.9) } }`). Mobile is
// never zoomed. Persisted in localStorage so each device keeps its own comfort level.
// A few "showcase" pages (landing, login) always render full-size via a data-attribute override.
const KEY = "gv_zoom";
const DEFAULT = "0.9";

export const ZOOM_OPTIONS = [
  { pct: 100, value: "1" },
  { pct: 90, value: "0.9" },
  { pct: 80, value: "0.8" },
  { pct: 70, value: "0.7" },
];

// Pages that should always render at 100% (no zoom-out), regardless of the user's setting.
export function isFullZoomPath(pathname) {
  if (!pathname) return false;
  return pathname === "/" || pathname === "/login" || pathname === "/register";
}

export function getZoom() {
  try { return localStorage.getItem(KEY) || DEFAULT; } catch { return DEFAULT; }
}

export function applyZoom(value) {
  const v = value || DEFAULT;
  try { localStorage.setItem(KEY, v); } catch { /* private mode */ }
  if (typeof document !== "undefined") {
    document.documentElement.style.setProperty("--gv-zoom", v);
  }
  return v;
}
